import { canAccessReports } from '@/router/guardsReports';

export default [
  {
    path: '/relatorios',
    beforeEnter: canAccessReports,
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Relatórios Histórico',
        path: 'historico',
        component: () => import('@/views/relatorios/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Relatórios' }]
        },
        beforeEnter: canAccessReports
      },
      {
        name: 'Relatórios Editar',
        path: 'edit/:id',
        component: () => import('@/views/relatorios/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Relatórios', path: '/relatorios/historico' }, { name: 'Editar' }]
        },
        beforeEnter: canAccessReports
      },
      {
        name: 'Relatórios Adicionar',
        path: 'edit',
        component: () => import('@/views/relatorios/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Relatórios', path: '/relatorios/historico' }, { name: 'Adicionar' }]
        },
        beforeEnter: canAccessReports
      },
      {
        name: 'Relatórios Visualizar SQL',
        path: 'visualizar-sql/:id',
        component: () => import('@/views/relatorios/VisualizarSql.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [{ name: 'Relatórios', path: '/relatorios/historico' }, { name: 'Visualizar SQL' }]
        },
        beforeEnter: canAccessReports
      },
      {
        name: 'Relatórios Visualizar',
        path: 'visualizar/:id',
        component: () => import('@/views/relatorios/Visualizar.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Relatórios', path: '/relatorios/historico' }, { name: 'Visualizar' }]
        },
        beforeEnter: canAccessReports
      },
      {
        name: 'Relatórios Modelo',
        path: 'modelo/:id',
        component: () => import('@/views/relatorios/Modelo.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Relatórios', path: '/relatorios/historico' }, { name: 'Adicionar' }]
        },
        beforeEnter: canAccessReports
      }
    ]
  }
];
